export default __webpack_public_path__ + "static/media/avatars(3).ef3d982f.png";